import React, { useState } from "react";
import Confirm from "../../../../../../../Components/Popups/Confirm";
import CircularProgress from "@mui/material/CircularProgress";
import { MdDelete } from "react-icons/md";
import { useTranslation } from "react-i18next";

const CreditCard = ({
  id,
  last_digits,
  brand,
  exp_month,
  exp_year,
  isDefault,
  handleDefaultCard,
  handleDeleteCard,
  deleteLoader,
  loading,
  total,
}) => {
  const { t } = useTranslation("finances");
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  return (
    <div className="relative w-[280px]">
      {/* Delete Popup */}
      <Confirm
        text={t("card.deleteConfirm")}
        open={!!deleteConfirm}
        setOpen={setDeleteConfirm}
        loader={deleteLoader}
        handleConfirm={() => handleDeleteCard(deleteConfirm)}
      />

      {/* Credit Card */}
      <div
        className="
          rounded-xl text-white p-4
          shadow-lg relative overflow-hidden
          bg-gradient-to-br from-indigo-600 via-brand to-indigo-700
          h-36 w-[280px] flex flex-col justify-between
        "
      >
        {/* Delete Button */}
        {!isDefault && total > 1 && (
          <MdDelete
            size={22}
            className="absolute top-3 right-3 text-white/70 hover:text-red-300 cursor-pointer transition"
            onClick={() => setDeleteConfirm(id)}
          />
        )}

        {/* Brand */}
        <div className="text-sm tracking-wider opacity-80 uppercase">
          {brand}
        </div>

        {/* Chip */}
        <div className="w-10 h-7 bg-yellow-300 rounded-sm opacity-90 mt-1 shadow-inner"></div>

        {/* Number */}
        <div className="text-lg tracking-widest font-semibold">
          •••• •••• •••• {last_digits ?? "xxxx"}
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center text-xs">
          <div className="opacity-90">
            {t("card.expires")} {exp_month < 10 ? `0${exp_month}` : exp_month}/
            {String(exp_year).slice(2)}
          </div>

          {isDefault ? (
            <span
              className="bg-indigo-700 text-white font-semibold px-2 py-0.5 
                   rounded text-[10px] shadow-sm"
            >
              {t("card.defaultUpper")}
            </span>
          ) : (
            <button
              disabled={loading}
              onClick={() => handleDefaultCard(id)}
              className={`
                text-[10px] px-2 py-0.5 rounded transition shadow-sm
                ${
                  loading
                    ? "bg-ui-border text-ui-text-muted cursor-not-allowed"
                    : "bg-white/20 hover:bg-white/30 text-white cursor-pointer"
                }
              `}
            >
              {loading ? (
                <CircularProgress size={10} sx={{ color: "white" }} />
              ) : (
                t("card.setDefault")
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditCard;
